<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZaOpLZ/tc-custom/9781615951826.jpg?1718251154683" alt="This image is the cover for the book Sorrow Without End, Medieval Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sorrow Without End, Medieval Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><i>"Excellent...oozes with suspense and intrigue."</i> —Booklist</p><p>As the autumn storms of 1271 ravage the East Anglian coast, Crowner Ralf finds the corpse of a brutally murdered soldier in the woods near Tyndal Priory. The dagger in the man's chest is engraved with a strange, cursive design, and the body is wrapped in a crusader's cloak. Was the murder the act of a member of the Assassin sect, or was the weapon meant to mislead him in finding the killer?</p><p>Ralf's decision to take the corpse to the priory for advice may be reasonable, but he is soon caught up in a maelstrom of conflict, both personal and political. The priory is deeply divided over whether to purchase a relic. The decision could endanger both Prioress Eleanor's leadership and the future of the hospital. Brother Thomas becomes a suspect in the murder itself, and Ralf must choose between the demands of his brother, the sheriff, and loyalty to a friend.</p><p>Meanwhile, the murderer watches and waits.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Priscilla Royal
      </h2>
      
      <p class="authorDescription body article"><P>Priscilla Royal grew up in British Columbia and earned a B.A. in World Literature at San Francisco State University, where she discovered the beauty of medieval literature. She is a theater fan as well as a reader of history, mystery, and fiction of lesser violence. When not hiding in the thirteenth century, she lives in Northern California and is a member of California Writers Club, Mystery Writers of America, and Sisters in Crime.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05a0a132